import React from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import PropTypes from 'prop-types';

import styles from './index.css';

export class Pagination extends React.Component {
    constructor(props) {
        super(props);

        const displayPages = 7;
        const currentPage = this.props.currentPage;
        this.state = {
            displayPages,
            currentPage,
            pages: this.buildPaginationArray(this.props.numberOfPages, currentPage, displayPages)
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.currentPage !== prevProps.currentPage || this.props.numberOfPages !== prevProps.numberOfPages) {
            this.setState((prevState) => ({
                currentPage: this.props.currentPage,
                pages: this.buildPaginationArray(this.props.numberOfPages, this.props.currentPage, prevState.displayPages)
            }));
        }
    }

    buildPaginationArray(numberOfPages, currentPage, maxNumberOfPages) {
        if ([undefined, null].includes(numberOfPages) || [undefined, null].includes(currentPage) || [undefined, null].includes(maxNumberOfPages)) return [];

        const pagesToDisplay = Math.min(maxNumberOfPages, numberOfPages);
        const start = Math.min(numberOfPages - pagesToDisplay, Math.max(0, currentPage - Math.floor(pagesToDisplay / 2)));
        return new Array(pagesToDisplay).fill(undefined).map((_, i) => i + start);
    }

    select(page) {
        this.setState((prevState) => ({
            currentPage: page,
            pages: this.buildPaginationArray(this.props.numberOfPages, page, prevState.displayPages)
        }));

        if (this.props.onSelect) this.props.onSelect(page);
    }

    render() {
        return (
            <div>
                {this.state.pages.length > 0 && (
                    <ButtonGroup aria-label="outlined primary button group" color="primary" variant="contained">
                        <Button disabled={this.props.disabled || this.state.currentPage === 0} onClick={() => this.select(0)}>
                            <FirstPageIcon className={styles.icon} />
                        </Button>
                        <Button disabled={this.props.disabled || this.state.currentPage === 0} onClick={() => this.select(this.state.currentPage - 1)}>
                            <NavigateBeforeIcon className={styles.icon} />
                        </Button>
                        {this.state.pages.map((page) => (
                            <Button disabled={this.props.disabled || page === this.state.currentPage} key={page} onClick={() => this.select(page)}>{page + 1}</Button>
                        ))}
                        <Button disabled={this.props.disabled || this.state.currentPage === (this.props.numberOfPages - 1)} onClick={() => this.select(this.state.currentPage + 1)}>
                            <NavigateNextIcon className={styles.icon} />
                        </Button>
                        <Button disabled={this.props.disabled || this.state.currentPage === (this.props.numberOfPages - 1)} onClick={() => this.select(this.props.numberOfPages - 1)}>
                            <LastPageIcon className={styles.icon} />
                        </Button>
                    </ButtonGroup>
                )}
            </div>
        )
    }
}

Pagination.propTypes = {
    currentPage: PropTypes.number,
    disabled: PropTypes.bool,
    numberOfPages: PropTypes.number,
    onSelect: PropTypes.func
};
